@use 'variables' as *;
@use 'mixins' as *;
@use 'sass:map';

$skeleton-sizes: (
  'xl': 3.5rem,
  'l': 3rem,
  'm': 2.5rem,
  's': 2rem,
  'xs': 1.5rem
);

:host {
  /**
   * @prop --background: The background color of the skeleton.
   * @prop --highlight: The highlight color of the skeleton.
   * @prop --speed: The animation speed.
   */
  display: flex;
  flex-direction: column;
  position: relative;

  --background: #{cat-token('color.ui.background.skeleton')};
  --highlight: #{cat-token('color.ui.background.skeletonHighlight')};
  --speed: 2s;
}

:host([variant='square']),
:host([variant='circle']) {
  display: inline-flex;
}

:host([hidden]) {
  display: none;
}

:host([variant='head']:not(:last-child)) {
  margin-bottom: $cat-head-margin-bottom;
}

:host([variant='body']:not(:last-child)) {
  margin-bottom: $cat-body-margin-bottom;
}

.skeleton {
  display: block;
  border-radius: cat-border-radius('m');
  background: var(--background);
}

.skeleton-circle {
  border-radius: 10rem;
}

// ----- size

@mixin size($size, $lvl) {
  $-text-offset: 4px;
  .skeleton-#{$size} {
    &.skeleton-rectangle {
      width: var(--width, 100%);
      height: var(--height, map.get($skeleton-sizes, $size));
    }

    &.skeleton-square,
    &.skeleton-circle {
      width: var(--width, map.get($skeleton-sizes, $size));
      height: var(--height, map.get($skeleton-sizes, $size));
    }

    &.skeleton-head,
    &.skeleton-body {
      width: var(--width, var(--line-width, 100%));
    }

    &.skeleton-head {
      height: calc(#{cat-head-font-size($lvl)} - #{$-text-offset});
      margin: calc((#{cat-head-line-height($lvl)} - #{cat-head-font-size($lvl)} + #{$-text-offset}) * 0.5) 0;
    }

    &.skeleton-body {
      height: calc(#{cat-body-font-size($size)} - #{$-text-offset});
      margin: calc((#{cat-body-line-height($size)} - #{cat-body-font-size($size)} + #{$-text-offset}) * 0.5) 0;
    }
  }
}

@include size('xs', 5);
@include size('s', 4);
@include size('m', 3);
@include size('l', 2);
@include size('xl', 1);

// ----- animation

.skeleton-sheen {
  background: linear-gradient(90deg, var(--background) 33%, var(--highlight) 50%, var(--background) 66%)
    var(--background);
  background-size: 300% 100%;
  animation: sheen var(--speed) ease-in-out infinite;
}

.skeleton-pulse {
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: var(--highlight);
    animation: var(--speed) ease-in-out 0.5s infinite normal none running pulse;
    opacity: 0;
  }
}

@keyframes sheen {
  0% {
    background-position: right;
  }
}

@keyframes pulse {
  50% {
    opacity: 1;
  }
}
